import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-checkmark-01',
	templateUrl: './icon-checkmark-01.component.svg',
})
export class IconCheckmark01Component {}
